// Shared shapes for the self-service "request access" flow. Deliberately
// decoupled from the backend: a Workplace is any org node the user can pick
// (label + breadcrumb, tree hidden), a Department is any pickable team/dept.
// The flow emits a RequestPayload that maps 1:1 onto OnboardingRequest
// (org_node_id + role_note) — wiring happens later.

export type { Workplace } from "@/lib/orgTree";

export type Department = {
  id: string; // the requestable role's id
  name: string; // e.g. "Channel Sales"
  description?: string; // plain-language, no permission jargon (optional — teams have none)
};

export type Profile = {
  name: string;
  email: string;
};

export const OTHER_DEPARTMENT_ID = "__other__";

// What the flow produces on submit. role_note is the human-readable intent an
// admin reads when reviewing — a department name, or the user's own words.
// name/password set the real credentials (email came from Slack sign-in).
export type RequestPayload = {
  org_node_id: string;
  requested_role_id: string | null; // the picked role's id; null for "Other"
  role_note: string;
  name: string;
  password: string;
  password_confirmation: string;
};
